export const CodeBookModelData = function () {
  return {
    codeBookList: [],
    searchedCodeBookList: []
  }
}
